import { render, staticRenderFns } from "./SupplierReport.vue?vue&type=template&id=f2abe51e&scoped=true"
import script from "./SupplierReport.vue?vue&type=script&lang=js"
export * from "./SupplierReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2abe51e",
  null
  
)

export default component.exports